import { wealthProApi } from "../../redux/api";

const archiveApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['factFindArchive']
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchFactFindArchiveStatus: builder.query({
            query: ({ masterAccountId }) => `api/factfind/archive/${masterAccountId}`,
            providesTags: (_r, err, { masterAccountId }) => err ? [] : [{ type: 'factFindArchive', id: masterAccountId }]
        }),
        archiveFactFind: builder.mutation({
            query: ({ masterAccountId, ...body }) => ({
                url: `api/factfind/archive/${masterAccountId}`,
                method: 'POST',
                body
            }),
            invalidatesTags: (_r, err, { masterAccountId }) => err ? [] : [{ type: 'factFindArchive', id: masterAccountId }]
        }),
        fetchFactFindPdf: builder.query({
            query: ({ masterAccountId, preview = false }) => `api/factfind/archive/${masterAccountId}/pdf${preview ? '?preview=true' : ''}`
        })
    })
})

export const {
    useFetchFactFindArchiveStatusQuery,
    useArchiveFactFindMutation,
    useLazyFetchFactFindPdfQuery
} = archiveApiEndpoints;